/* ADD GROUPS */
export const ADD_GROUP_PARTICIPANT = "ADD_GROUP_PARTICIPANT"
export const ADD_GROUP_PARTICIPANT_SUCCESS = "ADD_GROUP_PARTICIPANT_SUCCESS"
export const ADD_GROUP_PARTICIPANT_CLEAN = "ADD_GROUP_PARTICIPANT_CLEAN"
export const ADD_GROUP_PARTICIPANT_ERROR = "ADD_GROUP_PARTICIPANT_ERROR"
